const ANIMATED_ILLUSTRATION_NAME_REGEX = /[^a-z_]|^ic_|_ic_|^ic/g;

export function validAnimatedIllustrationName(animatedIllustrationName) {
  return (
    animatedIllustrationName &&
    !animatedIllustrationName.match(ANIMATED_ILLUSTRATION_NAME_REGEX)
  );
}

export function getAnimatedIllustrationNameError(animatedIllustrationName) {
  if (!animatedIllustrationName) {
    return 'Animated Illustration name cannot be empty';
  }

  if (animatedIllustrationName.match(/[A-Z]/g)) {
    return 'Uppercase characters not allowed';
  }

  if (animatedIllustrationName.match(/[\d]/g)) {
    return 'Numeric characters not allowed';
  }

  if (animatedIllustrationName.match(/[^a-z_]/g)) {
    return 'Special characters except _ not allowed';
  }

  if (animatedIllustrationName.match(/^ic_/g)) {
    return `Animated Illustration name shouldn't start with ic_`;
  }

  if (animatedIllustrationName.match(/^ic/g)) {
    return `Animated Illustration name shouldn't start with ic`;
  }

  if (animatedIllustrationName.match(/_ic_/g)) {
    return `Animated Illustration name shouldn't contain characters _ic_`;
  }
}
